
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"106","height":"39","viewBox":"0 0 1060 390"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#76bd22"}},[_c('path',{attrs:{"d":"M513 380c-23-9-23-12-23-183 0-121 4-177 12-185 9-9 84-12 275-12 249 0 263 1 273 19 6 11 10 87 10 175 0 213 25 196-282 195-134 0-253-4-265-9zm505-32c8-8 12-52 12-130V99l-77 67c-106 90-155 118-195 110-34-7-103-53-190-128l-58-50v119c0 79 4 123 12 131 17 17 479 17 496 0zM825 223c61-41 185-145 195-163 19-36-6-40-241-40-125 0-234 3-243 6s-16 14-16 24c0 27 216 200 249 200 9 0 34-12 56-27zM7 314c-20-20 6-24 154-24 124 0 160 3 157 13-4 9-45 13-154 15-83 1-153-1-157-4zM97 204c-20-20 6-24 154-24 124 0 160 3 157 13-4 9-45 13-154 15-83 1-153-1-157-4zM7 94c-18-19 18-24 159-24 120 0 155 3 152 13-4 9-45 13-154 15-83 1-153 0-157-4z"}})])])
          )
        }
      }
    